export default {
  History: 'Historia',
  Load_More: 'Carga más',
  Transactions: 'Actas',
  Activity: 'Actividad',
  View_Entire_History: 'Ver toda la historia',
  Empty: 'Las transacciones completadas se mostrarán aquí.',
};
